/**
 * Iranian mobile number format — 11 digits, starting with "09".
 *
 * This is client-side format guidance only, not a security boundary: the
 * backend's `loginIdentifier` (packages/auth/src/service.ts,
 * `normalizeLoginIdentifier`) accepts any non-empty string and enforces no
 * shape on it — the backend remains the sole authority on whether an
 * identifier resolves to a real account (AGENTS.md §2.3, "Authorization is
 * enforced in the backend"). Rejecting an obviously-malformed number here
 * only saves the user a round trip; it never substitutes for a server-side
 * check.
 */
export const IRAN_MOBILE_PATTERN = '09[0-9]{9}';

const IRAN_MOBILE_REGEX = /^09\d{9}$/;

export function toEnglishDigits(value: string): string {
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] as const;
  const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'] as const;
  let result = value;
  for (let i = 0; i < 10; i++) {
    const p = persianDigits[i];
    const a = arabicDigits[i];
    if (p !== undefined) result = result.replaceAll(p, String(i));
    if (a !== undefined) result = result.replaceAll(a, String(i));
  }
  return result;
}

export function isValidIranMobileNumber(value: string): boolean {
  return IRAN_MOBILE_REGEX.test(toEnglishDigits(value).trim());
}

export const IRAN_MOBILE_VALIDATION_MESSAGE = 'شماره همراه باید با ۰۹ شروع شود و ۱۱ رقم باشد.';
